module.exports = __webpack_public_path__ + "images/backgrounds/wave.bb289a4f00f13e8ca52e.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/wave.png
// module id = PCPF
// module chunks = 13